import difference from "lodash/difference";
import forEach from "lodash/forEach";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import getGraphEdgeSources from "../nodeOrEdgeSourceDataHandling/getGraphEdgeSources";
import getGraphNodeSources from "../nodeOrEdgeSourceDataHandling/getGraphNodeSources";
const restoreNodeSelection = (node, graphComponentRef, selected) => {
    var _a;
    const nodeSourceIds = map(getGraphNodeSources(node), "NodeId");
    if (isEmpty(difference(nodeSourceIds, selected))) {
        (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.selection.setSelected(node, true);
    }
};
const restoreEdgeSelection = (edge, graphComponentRef, selected) => {
    var _a;
    const edgeSourceIds = map(getGraphEdgeSources(edge), "EdgeId");
    if (isEmpty(difference(edgeSourceIds, selected))) {
        (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.selection.setSelected(edge, true);
    }
};
export default (graphComponentRef, selected) => {
    var _a, _b, _c;
    (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.selection.clear();
    if (!selected.length)
        return;
    forEach((_b = graphComponentRef.current) === null || _b === void 0 ? void 0 : _b.graph.nodes.toArray(), (node) => {
        restoreNodeSelection(node, graphComponentRef, selected);
    });
    forEach((_c = graphComponentRef.current) === null || _c === void 0 ? void 0 : _c.graph.edges.toArray(), (edge) => {
        restoreEdgeSelection(edge, graphComponentRef, selected);
    });
};
